module.exports = __webpack_public_path__ + "static/img/19.82f9319.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/customization/19.png
// module id = heOq
// module chunks = 1